

import { EventEmitter } from "@angular/core";
import { HeaderFilter } from "FoxxyInterfaces";

//#8567
export enum StatusSomaSortimentierenEnum
{
    NotSet = "NOT_SET",
    Neu = "NEU",
 //   Bereit_fuer_Uebergabe = "BEREIT_FUER_UEBERGABE",
  //  Uebergabe = "UEBERGABE",
    Uebergabe_moeglich = "UEBERGABE_MOEGLICH",
    Uebergabe_erfolgt ="UEBERGABE_ERFOLGT",
    //vorläufig nicht verwendet 22.05.2026 GA/SH
    // Geloescht = "GELOESCHT",

}


export class StatusSomaSortimentierenDefaults
{

  onError = new EventEmitter<any>();

  static list: StatusSomaSortimentierenDef[] = [
    <StatusSomaSortimentierenDef>{value: StatusSomaSortimentierenEnum.Neu, text: "Neu", iconstyle: "color: gray;", canFilter: true,   },

 //   <StatusSomaSortimentierenDef>{value: StatusSomaSortimentierenEnum.Bereit_fuer_Uebergabe, text: "Bereit für Übergabe an Wup", iconstyle: "color: yellow;"  , canFilter: true   },
 //   <StatusSomaSortimentierenDef>{value: StatusSomaSortimentierenEnum.Uebergabe, text: "Übergabe an WUP", iconstyle: "color: green;"  , canFilter: true   },
    <StatusSomaSortimentierenDef>{value: StatusSomaSortimentierenEnum.Uebergabe_moeglich, text: "Übergabe an WUP möglich", iconstyle: "color: blue;" , canFilter: true  },
    <StatusSomaSortimentierenDef>{value: StatusSomaSortimentierenEnum.Uebergabe_erfolgt, text: "Übergabe erfolgt", iconstyle: "color: blue;" , canFilter: true  },
   // <StatusSomaSortimentierenDef>{value: StatusSomaSortimentierenEnum.Geloescht, text: "Gelöscht", iconstyle: "color: blue;" , canFilter: true    },
  ];

  constructor()
  {
  }

  /**Alle erlaubten Soma Stati für die View */
  static getAllowedFilters() : HeaderFilter[]
  {
    let arr = new Array<HeaderFilter>();
    arr = this.list.filter(f=> f.canFilter == true ).map(f => <HeaderFilter>{
      text: f.text,
      value: f.value
    });
    return arr;
  }


  /**Filter auf die Default/Standard Statis
   * wird initial gesetzt in Filterung
  */
  static getDefaultFilter() : HeaderFilter[]
  {
    let arr = new Array<HeaderFilter>();
    arr = this.list.filter(f=> f.value !=  StatusSomaSortimentierenEnum.NotSet
      &&  f.value != StatusSomaSortimentierenEnum.Uebergabe_erfolgt
     ).map(f => <HeaderFilter>{
      text: f.text,
      value: f.value
    });
    return arr;
  }

  /**Eine StatusDefintion nach enum holen  */
  static get(e: StatusSomaSortimentierenEnum) : StatusSomaSortimentierenDef
  {
    return this.list.find(f=> f.value == e);
  }




}

export class StatusSomaSortimentierenDef
{
  value: StatusSomaSortimentierenEnum;
  text: string;
  iconstyle: string;
  canFilter: boolean;
}

